import type {Command, EditorView} from '@codemirror/view'

import {WRAP_DELIMITER_MAP, type WrappableDelimiter} from './constants'
import {wrapSelectionWithDelimiter} from './utils'

export const wrapWithDelimiter =
  (delimiter: WrappableDelimiter): Command =>
  view => {
    if (view.state.selection.main.empty) return false

    if (delimiter === '`' || delimiter === '~') {
      return wrapSelectionWithFence(view, delimiter)
    }

    const suffix = WRAP_DELIMITER_MAP[delimiter]
    wrapSelectionWithDelimiter(view, delimiter, suffix)

    return true
  }

const wrapSelectionWithFence = (view: EditorView, fenceChar: '`' | '~'): boolean => {
  const {doc, selection} = view.state
  const range = selection.main

  const doubleFenceLength = 2
  const doubleFence = fenceChar.repeat(doubleFenceLength)
  const prefixStart = Math.max(0, range.from - doubleFenceLength)
  const prefixSample = doc.sliceString(prefixStart, range.from)
  const suffixSample = doc.sliceString(range.to, range.to + doubleFenceLength)
  const hasDoublePrefix = range.from >= doubleFenceLength && prefixSample === doubleFence
  const hasDoubleSuffix = suffixSample === doubleFence

  if (hasDoublePrefix && hasDoubleSuffix) {
    const selectionText = doc.sliceString(range.from, range.to)
    const prefix = `${fenceChar}\n`
    const suffix = selectionText.endsWith('\n') ? fenceChar : `\n${fenceChar}`
    wrapSelectionWithDelimiter(view, prefix, suffix)
    return true
  }

  wrapSelectionWithDelimiter(view, fenceChar, fenceChar)
  return true
}
